export const getIsTaskFilterExam = (string: string) => {
    return string === "8_kl" ||
        string === "matura_podstawowa" ||
        string === "matura_rozszerzona"
        ? true
        : false;
};
